import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    id: '01',
    emoji: '📝',
    title: 'Banco de 100 Actividades para Docentes',
    desc: 'Individuales, grupales, estudios de caso argentinos, crucigramas, proyectos y juegos. Organizadas por nivel y tiempo disponible: desde 10 minutos hasta clase completa.',
    value: '$18.000 ARS'
  }, {
    id: '02',
    emoji: '📋',
    title: 'Banco Completo de Evaluaciones',
    desc: '167 instrumentos: diagnósticas, formativas, sumativas, recuperatorios, rúbricas y autoevaluaciones. Con banco de 100 preguntas con respuestas para armar tus propias evaluaciones en minutos.',
    value: '$15.000 ARS'
  }, {
    id: '03',
    emoji: '📅',
    title: 'Planificaciones Docentes Anuales y Trimestrales',
    desc: 'Planificación anual, trimestrales y mensuales para todo el ciclo 2026. Con secuencias didácticas modelo, indicadores de logro y cronograma de evaluaciones. Alineado con el Marco de Referencia INET.',
    value: '$20.000 ARS'
  }, {
    id: '04',
    emoji: '🗺️',
    title: 'Recursos Didácticos: Infografías, Fichas y Mapas',
    desc: 'Más de 200 recursos listos para proyectar o imprimir: infografías del ciclo minero, el mapa minero argentino para colgar en el aula, fichas técnicas de los 16 minerales más importantes de Argentina y glosario de 120 términos.',
    value: '$15.000 ARS'
  }, {
    id: '05',
    emoji: '🔬',
    title: '20 Proyectos y Talleres Prácticos Completos',
    desc: 'Proyectos integradores, talleres de flotación y separación magnética en el aula, 7 casos reales argentinos (Cauchari, Veladero, Josemaría, Navidad y más) y 5 experiencias de laboratorio con materiales simples.',
    value: '$12.000 ARS'
  }];
  return <section className="py-20 bg-forest text-white relative overflow-hidden" data-id="element-20">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-21"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-earth/20 rounded-full blur-3xl" data-id="element-22"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/20 text-gold mb-6" data-id="element-25">
            <Gift className="w-8 h-8" data-id="element-26" />
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-27">
            🎁 5 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-gold font-bold" data-id="element-28">
            SIEMPRE INCLUIDOS · SIEMPRE GRATIS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-29">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`bg-forest-dark border border-forest-soft rounded-2xl p-6 flex flex-col h-full relative overflow-hidden group hover:border-gold/50 transition-colors ${i === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-30">
              <div className="absolute top-0 right-0 bg-forest-soft text-gold text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-31">
                Bono {bono.id}
              </div>

              <div className="flex items-start gap-4 mb-4 mt-2" data-id="element-32">
                <div className="text-4xl" data-id="element-33">{bono.emoji}</div>
                <div data-id="element-34">
                  <h3 className="text-xl font-bold text-white leading-tight mb-2" data-id="element-35">
                    {bono.title}
                  </h3>
                  <p className="text-sand text-sm leading-relaxed" data-id="element-36">
                    {bono.desc}
                  </p>
                </div>
              </div>

              <div className="mt-auto pt-4 border-t border-forest flex items-center justify-between" data-id="element-37">
                <span className="text-sand/60 line-through text-sm" data-id="element-38">
                  Valor {bono.value}
                </span>
                <span className="text-gold font-black tracking-wide" data-id="element-39">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-40">
          <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-8 py-4" data-id="element-41">
            <p className="text-lg" data-id="element-42">
              Valor total bonos{' '}
              <span className="line-through opacity-50" data-id="element-43">$80.000 ARS</span>{' '}
              <span className="text-gold font-bold mx-2" data-id="element-44">→</span>{' '}
              <span className="font-black text-xl" data-id="element-45">GRATIS con tu Megapack</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}